import { useState, useCallback } from 'react';

export function useNotifications() {
  const [permission, setPermission] = useState(() =>
    'Notification' in window ? Notification.permission : 'denied'
  );

  const requestPermission = useCallback(async () => {
    if (!('Notification' in window)) return 'denied';
    if (Notification.permission === 'granted') {
      setPermission('granted');
      return 'granted';
    }
    const result = await Notification.requestPermission();
    setPermission(result);
    return result;
  }, []);

  const notify = useCallback((title, body, onClick) => {
    if (!('Notification' in window) || Notification.permission !== 'granted') return;
    const n = new Notification(title, {
      body,
      icon: '/favicon.ico',
      tag: title,
      requireInteraction: false,
    });
    n.onclick = () => {
      window.focus();
      if (onClick) onClick();
      n.close();
    };
    setTimeout(() => n.close(), 10000);
    return n;
  }, []);

  return { permission, requestPermission, notify };
}
